import React from 'react'
import _ from '/home/ps/root'
// import Store from './store'
export default class View extends React.Component {
  // static store = Store
  static HTM = 'div'
  // static view = (p, id, v=_.MASTER) => (p[_.INIT][v] ? (id ? p[_.INIT][v][_.RESPONSE][id] : p[_.INIT][v][_.RESPONSE]) : {})
  // static init = (view, expect) => { // pure
  //   const test = view[_.TEST]
  //   var result = true
  //   if (test) {
  //     Object.keys(test).forEach(key => {
  //       switch (key) {
  //         case _.VERIFY:
  //         case _.LOGIN:
  //         result = expect==test[key]
  //         // !result && console.log(`View.init key ${key}, expect ${expect}, result ${result}, view`, view)
  //         break
  //       }
  //     })
  //   }
  //   return result
  // }
  static bind = (js, that) => { // pure
    if (!js) return {}
    if (that) that.js = {}
    // const {func: _func, ..._object} = js
    const {func, ...object} = js
    // const {static: _static, ..._non_static} = _func
    const {_static, ...non_static} = func
    const {request, response, init, ...static_func} = _static || {}
    // console.log({_func, _object, _static, _non_static, _request, _response, _init})
    // // console.log(Object.keys(_func))
    // console.log(Object.keys(_object))
    // // console.log(Object.keys(_static))
    // console.log(Object.keys(_non_static))
    const _js = {
      ...Object.keys(object).reduce((acc, curr) => {
        // if (that) that[_.JS][curr]=_object[curr]
        acc[curr] = object[curr]
        return acc
      }, {}),
      // [_.REQUEST]: new Function(_request),
      // [_.RESPONSE]: new Function(_response),
      // [_.INIT]: Object.keys(_init).reduce((acc, curr) => {
      //   acc[curr] = new Function(_init[curr])
      //   return acc
      // }, {}),
      ...Object.keys(non_static).reduce((acc, curr) => {
        // console.log(_non_static[curr])
        // if (that.props.body.id=='otpsend_') debugger
        const f = new Function(non_static[curr])
        acc[curr] = f
        if (that) f.bind(that)
        return acc
      }, {})
    }
    if (request) _js.request = new Function(request)
    if (response) _js.response = new Function(response)
    if (init) _js.init = Object.keys(init).reduce((acc, curr) => {
      acc[curr] = new Function(init[curr])
      return acc
    }, {})
    if (static_func) Object.assign(_js, Object.keys(static_func).reduce((acc, curr) => {
      const f = new Function(static_func[curr])
      acc[curr] = f
      if (that) f.bind(that)
      return acc
    }, {}))
// console.log(`View.bind js that`, js, that)
    return _js
  }
}
  // static view = (p, id, v = __.MASTER) => {debugger; return p[_.INIT][v] ? (id ? p[_.INIT][v][id] : p[_.INIT][v]) : null}
  // static bind = (state, that = null) => {
  //   const js = state.js
  //   if (!View[state.name]) {
  //     View[state.name] = {},
  //     View[state.name][__.REQUEST] =  View.request,
  //     View[state.name][__.RESPONSE] = View.response,
  //     View[state.name][__.INIT] = {[__.PART]: View.partInit}
  //   }
  //   if (js) {
  //     const bound = View.bind(js, that) // js coming with page
  //     if (bound[__.STATIC_]) { // override global static methods (static_request, static_response, static_init_field)
  //       if (bound[__.STATIC_][__.REQUEST])  View[state.name][__.REQUEST] = bound[__.STATIC_][__.REQUEST]
  //       if (bound[__.STATIC_][__.RESPONSE]) View[state.name][__.RESPONSE] = bound[__.STATIC_][__.RESPONSE]
  //       if (bound[__.STATIC_][__.INIT])     View[state.name][__.INIT] = {
  //         ...View[state.name][__.INIT],
  //         ...bound[__.STATIC_][__.INIT],
  //       } // override
  //     }
  //     delete(bound[__.STATIC_])
  //     if (that) that[__.JS] = bound
  //     console.log('View.bind replaced static with native', bound, View[state.name])
  //   }
  // }
    // return Object.keys(js || {}).reduce((accKey, key) => {

  // static _bind = (js, that) => { // pure
  //   const j = Object.keys(js || {}).reduce((accKey, key) => {
  //     switch (key) {
  //       case _.FUNC:
  //       // accKey[_.FUNC] = {}
  //       Object.keys(js[_.FUNC]).reduce((accFunc, func) => {
  //         switch (func) {
  //           case __.STATIC_: // static functions
  //           // accKey[_.FUNC][__.STATIC_] = {}
  //           accKey[func] = Object.keys(js[_.FUNC][func]).reduce((acc, sf) => {
  //             switch (sf) {
  //               case _.INIT:
  //               acc[sf] = {}
  //               const static_init = Object.keys(js[_.FUNC][func][sf])
  //               static_init.forEach(f => {
  //                 acc[sf][f] = new Function (js[_.FUNC][func][sf][f])
  //               })
  //               break
  //               default: // non static functions
  //               acc[sf] = new Function (js[_.FUNC][func][sf])
  //             } // switch (sf)
  //             return acc
  //           }, {})
  //           break // case __.STATIC_
  //           default: // non static functions
  //           const f = new Function (js[_.FUNC][func]);
  //           if (that)
  //             f.bind(that)
  //           accKey[func] = f
  //           break
  //         } // switch (func)
  //         return accFunc
  //       }, {}) // Object.keys (js[_.FUNC])
  //       break // case _.FUNC
  //       default: // not function only objects
  //       accKey[key] = js[key]
  //       break
  //     } // switch (key)
  //     return accKey
  //   }, {}) // Object.keys (js || {})
  //   // console.log(`View.bind id ${that.props.id} js`, js, 'j', j)
  //   return j
  // } // bind
  //   return j
  // }
